export const ingredientsData = [
    {
        id: 'to-buy',
        items: [
            {
                name: 'Asparagus',
                amount: '1 bunch'
            },
            {
                name: 'English peas',
                amount: '½ lb unshelled, ~1 cup'
            },
            {
                name: 'Shallots',
                amount: '4'
            },
            {
                name: 'Heavy cream',
                amount: '1 ¼ cup'
            },
            {
                name: 'Saffron',
                amount: 'amount'
            },
            {
                name: 'Pasta',
                note: 'wide, like fettuccine or tagliatelle',
                amount: '4 servings',
            },
            {
                name: 'Lemon (zest)',
                amount: '1'
            },
            {
                name: 'Parmesean (grated)',
                amount: '½ cup'
            },
            {
                name: 'Parsley',
                amount: '4 tbsp'
            },
            {
                name: 'Tarragon',
                amount: '4 tbsp'
            }
        ]
    },
    {
        id: 'pantry',
        name: 'Pantry',
        items: [
            { name: 'Olive oil' },
            { name: 'Salt' },
            { 
                name: 'Flakey sea salt',
                amount: 'optional, amount'
            }
        ]
    }
]